// AI Generated Component
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { MonNumberPipe } from '@monsido/core/locale/pipes/mon-number.pipe';
import { StateService } from '@uirouter/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { PagesFilesPagesComponent } from '@client/app/components/pages/files/pages/pages.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

/**
 * Inventory content links component
 */
@Component({
    selector: 'inventory-content-links',
    templateUrl: './inventory-content-links.component.html',
    standalone: false,
})
export class InventoryContentLinksComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    @Input() type: string = '';
    @Input() headline: string = '';
    @Input() icon: string = '';
    @Input() active?: string;
    @Input() exportType?: string;

    // Properties matching original component
    public links: any = [];
    public subheaderTranslation: string = '';
    public tabs: any[] = [];
    public promise: Promise<any> | null = null;
    public domainId: string = '';
    public scanDocuments: boolean = false;

    constructor (
        private linksRepoService: LinksRepoService,
        private translateService: TranslateService,
        private monNumberPipe: MonNumberPipe,
        private stateService: StateService,
    ) {
        super({ table: true, pages: true });
    }

    ngOnInit (): void {
        // Check for route data inputs
        const routeData = this.stateService.current?.data?.componentInputs;
        if (routeData) {
            this.type = routeData.type || this.type;
            this.headline = routeData.headline || this.headline;
            this.icon = routeData.icon || this.icon;
            this.active = routeData.active || this.active;
            this.exportType = routeData.exportType || this.exportType;
        }

        this.initializeComponent();
    }

    ngOnDestroy (): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initializeComponent (): void {
        this.links = [];
        this.search = '';
        this.domainId = this.stateService.params.domainId;
        this.scanDocuments = this.sessionService.domain?.scan?.scan_documents || false;
        this.subheaderTranslation = '';
        this.setupTabs();
        this.getPage();
    }

    private setupTabs (): void {
        this.tabs = [
            {
                name: this.translateService.getString('Internal'),
                value: 'internal',
            },
            {
                name: this.translateService.getString('External'),
                value: 'external',
            },
        ];
        this.activeTab = this.tabs[0].value;
    }

    public override getPage (): void {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search,
            type: this.type,
            relation: this.activeTab,
            page_fixed: false,
        };

        this.promise = this.linksRepoService.getAll(params).then((data) => {
            this.links = data;
            this.getSubHeaderDescription();
        });
    }

    private getSubHeaderDescription (): void {
        const total = Number(this.links.total) || 0;
        const formattedNumber = this.monNumberPipe.transform(total, '0,0');
        this.subheaderTranslation = this.translateService.getPlural(
            total,
            '1 result',
            '[[count]] results',
            { count: formattedNumber },
            '',
        );
    }

    public openDialog (link: any, type?: string): void {
        const params = {
            body: PagesFilesPagesComponent,
            size: 'lg',
            data: { link: link, domainId: this.domainId, active: this.active, icon: this.icon, type: type },
        };

        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }
}
